<!--
 * @Description: 班次规则表单组件
 * @Author: wanqian
 * @Date: 2022-03-25 16:43:52
-->
<template>
  <el-dialog width="640px" center :title="dialogTitle" :visible.sync="visible" :close-on-click-modal="false"
    @open="initData" :before-close="handleCancel" center>
    <el-form class="dutyRuleForm" ref="dutyRuleForm" :model="dutyRuleForm" :rules="rules" label-width="120px">
      <el-form-item label="所属机构：" prop="institutionId">
        <el-select style="width: 240px" size="small" v-model="dutyRuleForm.institutionId" filterable 
          placeholder="请输入/选择" :disabled="dataPvgList.includes('INST_6_DUTY_RULE_CHG')" clearable
          :filter-method="interactionUtil.debounce((value) => commonUtil.handleListFilter(value, 'institutionList', srcInstitutionList, this))"
					@visible-change="(visible) => 
            commonUtil.handleListFilterVisibleChange(visible, 'institutionList', srcInstitutionList, this)">
          <el-option v-for="item in institutionList" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="班次名称：" prop="name">
        <el-input size="small" clearable v-model.trim="dutyRuleForm.name" placeholder="请输入班次名称" 
          maxlength="10" autocomplete="off" style="width: 240px">
        </el-input>
      </el-form-item>
      <el-form-item label="颜色：" prop="color">
        <el-color-picker v-model="dutyRuleForm.color"></el-color-picker>
      </el-form-item>
      <el-form-item label="开始时间：" prop="startTime">
        <el-time-picker style="width: 240px" size="small" v-model="dutyRuleForm.startTime" placeholder="请选择开始时间" 
          :clearable="false" format = 'HH:mm'  value-format = 'HH:mm'>
        </el-time-picker>
      </el-form-item>
      <el-form-item label="结束时间：" prop="endTime">
        <el-time-picker style="width: 240px" size="small" v-model="dutyRuleForm.endTime" placeholder="请选择结束时间" 
          :clearable="false" format = 'HH:mm'  value-format = 'HH:mm'>
        </el-time-picker>
        <el-checkbox v-model="dutyRuleForm.spanDay" :true-label="1" :false-label="0" style="margin-left: 19px;">
          次日
        </el-checkbox>
      </el-form-item>
    </el-form>
    <div class="dialog-footer bk-wizard-bottons">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button type="primary" @click="handleSubmit('dutyRuleForm')">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import Constant from '@/global/Constant.js'

export default {
  name: 'DutyRuleForm',

  props: ["visible", "operate", "dutyId", "institutionId"],

  data() {
    let validStartTime = (_rule, _value, callback) => {
      if (!this.dutyRuleForm.startTime || this.dutyRuleForm.startTime.length == 0) {
        callback(new Error('请选择开始时间'));
      } else if (this.dutyRuleForm.startTime == this.dutyRuleForm.endTime && !this.dutyRuleForm.spanDay) {
        callback(new Error('开始时间和结束时间不能相同'));
      } else {
        callback();
      }
    };

    let validEndTime = (_rule, _value, callback) => {
      if (!this.dutyRuleForm.endTime || this.dutyRuleForm.startTime.endTime == 0) {
        callback(new Error('请选择结束时间'));
      } else if (this.dutyRuleForm.startTime == this.dutyRuleForm.endTime && !this.dutyRuleForm.spanDay) {
        callback(new Error('开始时间和结束时间不能相同'));
      } else {
        callback();
      }
    };

    return {
      dataPvgList: [],    //在角色配置页面上的操作权限
      dutyRuleForm: {color: "#64D2E8"},
      institutionList: [],
      srcInstitutionList: [],
      rules: {
        name: [{required: true, message: "请输入班次名称", trigger: "blur"}],
        institutionId: [{required: true, message: "请选择所属机构", trigger: "blur"},],
        color: [{required: true, message: "请选择颜色", trigger: "blur" },],
        startTime: [{required: true, validator: validStartTime, trigger: "blur"},],
        endTime: [{ required: true, validator: validEndTime, trigger: "blur"},]
      },
    }
  },

  computed: {
    dialogTitle() {
      return this.operate == "add" ? "新增班次" : "编辑班次";
    },
  },

  methods: {
    async initData() {
      await this.getDataPvg4CurRole();
      await this.queryFormData();
    },

    getDataPvg4CurRole() {
      return new Promise((resolve) => {
        let requestData = {
          method: 'GET',
          url: this.commonUrl.URL_GET_DATA_PVG_4_CURROLE,
          param: {entityKey: 'INST'},
        };
        this.vueRequest(requestData).then(result => {
          if (result != null) {
            this.dataPvgList = result.data;
            resolve();
          }
        })
      })
    },

    queryFormData() {
      this.clearVaild();
      return new Promise((resolve) => {
        let url = this.operate == "add" ? Constant.URL_GET_DUTY_RULE_4_ADD 
          : Constant.URL_GET_DUTY_RULE_4_UPDATE;
        let params = {'id': this.dutyId};
        let header = this.encryptionUtil.signatureParams(params,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: 'GET',
          url: url,
          param: this.operate == "add" ? {} : params,
          header: header,
          contentType: this.commonConst.CNTYPE_URLENCODED,
        };
        this.vueRequest(requestData).then(result => {
          if (result != null) {
            this.rebuildData(result.data);
            resolve();
          }
        })
      })
    },

    rebuildData(data) {
      this.dutyRuleForm = data;
      this.institutionList = this.dutyRuleForm.institutionList;
      this.srcInstitutionList = this.dutyRuleForm.institutionList;
      // 机构ID为0，赋空 ，
      if (this.dutyRuleForm.institutionId == 0) {
        this.dutyRuleForm.institutionId = '';
      }
      // 列表代入有机构ID（比如从列表有规则的机构旁边+那里新增传入机构ID），将机构ID赋值
      if (this.institutionId) {
        this.dutyRuleForm.institutionId = this.institutionId;
      }
      // privilege下superOrPrimary表示是都是超管或者主管，超管/主管机构可选择，机构管理员默认本机构不能选择
      if (!this.dataPvgList.includes('INST_6_DUTY_RULE_CHG')) {
        this.dutyRuleForm.institutionId = this.institutionList[0].id;
      }
      if (this.dutyRuleForm.color.indexOf('#') == -1) {
        this.$set(this.dutyRuleForm, 'color', '#'+this.dutyRuleForm.color);
      } else {
        this.$set(this.dutyRuleForm, 'color', this.dutyRuleForm.color);
      }
    },

    clearData() {
      //颜色默认蓝色
      this.dutyRuleForm = {color: "#64D2E8"};
    },

    clearVaild() {
			this.$nextTick(() => {
        this.$refs["dutyRuleForm"].clearValidate();
      });
		},

    handleSubmit (dutyRuleForm) {
      this.$refs[dutyRuleForm].validate((valid) => {
        if (!valid) return false;
        let url = this.operate == "add" ? Constant.URL_SAVE_DUTY_RULE : Constant.URL_UPDATE_DUTY_RULE;
        let method = (this.operate == 'add') ? 'POST' : 'PUT';
        let startTime = this.dutyRuleForm.startTime + ':00';
        let endTime = this.dutyRuleForm.endTime + ':00';
        let form = {
          'color': this.dutyRuleForm.color,
          'endTime': endTime,
          'id': this.operate == 'add' ? 0 : this.dutyId,
          'institutionId': this.dutyRuleForm.institutionId,
          'name': this.dutyRuleForm.name,
          'startTime': startTime,
          'spanDay': this.dutyRuleForm.spanDay
        };
        let header = this.encryptionUtil.signatureBody(form,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: method,
          url: url,
          param: form,
          header: header,
          contentType: this.commonConst.CNTYPE_JSON,
        };
        this.vueRequest(requestData).then((result) => {
          if (result != null) {
            this.clearData();
            this.$emit("close-dialog", true);
          }
        });
      });
    },

    handleCancel() {
      this.clearData();
      this.$emit("close-dialog", false);
    },
  },
}
</script>

<style scoped>
.dutyRuleForm {
  margin-left: 80px;
  margin-bottom: 60px;
}
.dialog-footer {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/instmng/components/DutyRuleForm.vue